import React from 'react';
import { GlobeIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
type PriceCtaProps = {
  label: string;
  note?: string;
  dark?: boolean;
};
export function PriceCta({
  label,
  note = 'Instant digital access · Digital educational product · No recurring fees',
  dark = false
}: PriceCtaProps) {
  return <div className="space-y-4" data-id="element-24" data-mp="18azdfk4snkn9">
      <CtaButton label={label} data-id="element-25" data-mp="18c0rlxh3wn97" />
      <p className={`flex items-center justify-center gap-1.5 text-center text-sm font-medium ${dark ? 'text-white/70' : 'text-ink/60'}`} data-id="element-26" data-mp="1d892uzs6nwb3">
        <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-27" data-mp="1h8t166oht5yt" />
        {note}
      </p>
      <Countdown dark={dark} data-id="element-28" data-mp="1mb0fh2wsoy4b" />
      <ScarcityBar dark={dark} data-id="element-29" data-mp="1m72wqie4q8ky" />
      <p className={`flex items-start gap-2 rounded-xl px-3 py-2.5 text-sm leading-snug ${dark ? 'bg-aqua/10 text-aqua-light' : 'bg-aqua/10 text-navy-800'}`} data-id="element-30" data-mp="2sqauec8g6n73">
        <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-31" data-mp="2hbl43e9lzxtt" />
        <span data-id="element-32" data-mp="2cbyr95xp0jlj">
          <strong data-id="element-33" data-mp="2cbf8jn07xr6g">Automatic currency conversion:</strong> the price is shown in USD and converted automatically to your local
          currency at checkout, depending on your payment provider and country.
        </span>
      </p>
    </div>;
}